const resultPageHandle = 'epigenetic-analysis-workflow-generator-results'
const resultCategory = 'Epigenetics'

function wufooFormDisplay(){
	$('#global-modal-center-title').text('')
	let modalHTML = ` <div id="wufoo-p11hnppz1hz4adc"> Fill out my <a href="https://zymoresearch.wufoo.com/forms/p11hnppz1hz4adc">online form</a>. </div>`;
	$('#global-modal-center-content').html(modalHTML);
	var p11hnppz1hz4adc; (function(d, t) { var s = d.createElement(t), options = { 'userName':'zymoresearch', 'formHash':'p11hnppz1hz4adc', 'autoResize':true, 'height':'645', 'async':true, 'host':'wufoo.com', 'header':'show', 'ssl':true }; s.src = ('https:' == d.location.protocol ?'https://':'http://') + 'secure.wufoo.com/scripts/embed/form.js'; s.onload = s.onreadystatechange = function() { var rs = this.readyState; if (rs) if (rs != 'complete') if (rs != 'loaded') return; try { p11hnppz1hz4adc = new WufooForm(); p11hnppz1hz4adc.initialize(options); p11hnppz1hz4adc.display(); } catch (e) { } }; var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr); })(document, 'script'); 
	$("#global-modal-center-btn").click();
}

$(document).ready(function () {
	document.getElementById('workflow-share').innerHTML +=	`
	<button onclick="wufooFormDisplay()" type="button" class="wf-header-button"><span class="header-icon"><i class="fa fa-envelope" aria-hidden="true"></i> Contact Us </span></button>
	`;
});

//input workflow object (manages input)
var inputWFObj = {
	"Sample": {
		"stepName": "Sample",
		"htmlText": "Sample Type",
		"sessionName": "sampleTypeDNAMethylation", //make sure it's unique between all workflow generators
		"value" : "", //will change depending on what's selected
		"stepType": "dependent", //dependent: show disabled
		"isAnchor": false, //use remove conflicts
		"isProduct": true
	},
	"Method": {
		"stepName": "Method",
		"htmlText": "Method",
		"sessionName": "methodDNAMethylation",
		"value" : "", //will change depending on what's selected
		"stepType": "dependent", //dependent: show disabled
		"isAnchor": false,
		"isProduct": true
	},
	"Analysis": {
		"stepName": "Analysis",
		"htmlText": "Analysis",
		"sessionName": "analysisDNAMethylation",
		"value" : "", //will change depending on what's selected
		"stepType": "dependent", //dependent: show disabled
		"isAnchor": false,
		"isProduct": true
	}
}

const resultCategories = ['Extraction Kit','Application Kit','Controls']

const mappedProducts = {
}

const autoInput = {
	"Sample":{
		"Reset" : ['Reset'],
		"Cells": ["Cells"],
		"Tissue": ["Tissue"],
		"FFPE": ["FFPE"],
		"cfDNA": ["cfDNA"],
		"Blood": ["Blood"],
		"Serum": ["Serum"],
		"Plasma": ["Plasma"],
		"Urine": ["Urine"],
		"Microbe": ["Microbe"],
		"Insect": ["Insect"],
		"Plant": ["Plant"],
    },
    "Method":{
		"Reset" : ['Reset'],
		"Bisulfite": ["Illumina Methylation Array@Bisulfite", "NGS@Bisulfite", "PCR/qPCR@Bisulfite"],
		"Non-Bisulfite": ["ELISA@Non-Bisulfite", "NGS@Non-Bisulfite", "qPCR@Non-Bisulfite"],
    }
	,
    "Analysis":{
		"Reset" : ['Reset'],
		"Whole Genome Bisulfite Sequencing": ["Whole Genome Bisulfite Sequencing"],
		"Reduced Representation Bisulfite Sequencing": ["Reduced Representation Bisulfite Sequencing"],
		"Bisulfite Specific": ["Bisulfite Specific"],
		"Methylation Specific": ["Methylation Specific"],
		"General/Other": ["General/Other"],
		"5-mC": ["5-mC"],
		"Fragmentomics": ["Fragmentomics"],
		"Chromatin": ["Chromatin"],
		"5-hmC": ["5-hmC"],
		"5-hmC Reduced Representation Hydroxymethylcytosine Profiling": ["5-hmC Reduced Representation Hydroxymethylcytosine Profiling"],
    }
}

const bulkProducts = 	["dna-rna-shield","dna-rna-shield-blood-collection-tube","dna-rna-shield-collection-tube-w-swab",
						"dna-rna-shield-collection-tube-w-swab-dx","dna-rna-shield-fecal-collection-kit","dna-rna-shield-fecal-collection-tube",
						"dna-rna-shield-fecal-collection-tube-dx","dna-rna-shield-lysis-and-collection-tubes","dna-rna-shield-safecollect-saliva-collection-kit",
						"dna-rna-shield-safecollect-swab-collection-kit","dna-rna-shield-saliva-collection-kit","dna-rna-shield-saliva-sputum-collection-kit-dx",
						"dnase-i-set","proteinase-k-w-storage-buffer-set","rnase-a","sterile-collection-swab","urine-conditioning-buffer",
						"zr-96-bashingbead-lysis-rack-barcoded","zymolyase"]

const resultData = { 
	"custom":{
	}
}

const customSize = {
	"D6421-PS1": "96 rxns, Primer Set 1",
	"D6421-PS2": "96 rxns, Primer Set 2",
	"D6421-PS3": "96 rxns, Primer Set 3",
	"D6421-PS4": "96 rxns, Primer Set 4",
	"D6421-PS5": "96 rxns, Primer Set 5",
	"D6421-PS6": "96 rxns, Primer Set 6",
	"D6421-PS7": "96 rxns, Primer Set 7",
	"D6421-PS8": "96 rxns, Primer Set 8",
	"D6430-PS1": "96 rxns, Primer Set 1",
	"D6430-PS2": "96 rxns, Primer Set 2",
	"D6430-PS3": "96 rxns, Primer Set 3",
	"D6430-PS4": "96 rxns, Primer Set 4",
	"R2061": "50 preps, (w/ 50 ml TRI Reagent)",
	"R2063": "100 preps, (w/ 100 ml TRI Reagent)",
	"R2051": "50 preps, (w/ 50 ml TRI Reagent)",
	"R2053": "200 preps, (w/ 200 ml TRI Reagent)",
	"R2071": "50 preps, (w/ 50 ml TRI Reagent)",
	"R2073": "200 preps, (w/ 200 ml TRI Reagent)",
	"R2055": "2 x 96 preps, (w/ 200 ml x 1 TRI Reagent)",
	"R2057": "4 x 96 preps, (w/ 200 ml x 2 TRI Reagent)",
	"R2103": "4 x 96 preps, (w/ 200 ml x 2 TRI Reagent)",
	"R2101": "1 x 96 preps, (w/ 50 ml x 2 TRI Reagent)",
	"R2100": "1 x 96 preps",
	"R1160-10": "10 pack , 1ml",
	"R1161-10": "10 pack , 2ml",
	"R1160-50": "50 pack , 1ml",
	"R1161-50": "50 pack , 2ml",
}


const autoOutput = {
	"Cells?NGS@Bisulfite?Whole Genome Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-miniprep",
		"Extraction Kit Numbers":"D3024,D3025",
		"Application Kit Handle":"zymo-seq-trio-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"zymo-seq-wgbs-library-kit",
		"Application Kit 2 Numbers":"D5465",
		"Application Kit 3 Handle":"pico-methyl-seq-library-prep-kit",
		"Application Kit 3 Numbers":"D5455,D5456",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"Tissue?NGS@Bisulfite?Whole Genome Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"zymo-seq-trio-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"zymo-seq-wgbs-library-kit",
		"Application Kit 2 Numbers":"D5465",
		"Application Kit 3 Handle":"pico-methyl-seq-library-prep-kit",
		"Application Kit 3 Numbers":"D5455,D5456",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"FFPE?NGS@Bisulfite?Whole Genome Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-ffpe-miniprep",
		"Extraction Kit Numbers":"D3067",
		"Application Kit Handle":"zymo-seq-trio-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"ez-dna-methylation-gold-kit",
		"Application Kit 2 Numbers":"D5005,D5006",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"cfDNA?NGS@Bisulfite?Whole Genome Bisulfite Sequencing": {
		"Extraction Kit Handle":"magicbead-cfdna-isolation-kit",
		"Extraction Kit Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-trio-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"Blood?NGS@Bisulfite?Whole Genome Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"zymo-seq-trio-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"zymo-seq-wgbs-library-kit",
		"Application Kit 2 Numbers":"D5465",
		"Application Kit 3 Handle":"pico-methyl-seq-library-prep-kit",
		"Application Kit 3 Numbers":"D5455,D5456",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"Serum?NGS@Bisulfite?Whole Genome Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"zymo-seq-trio-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"zymo-seq-wgbs-library-kit",
		"Application Kit 2 Numbers":"D5465",
		"Application Kit 3 Handle":"pico-methyl-seq-library-prep-kit",
		"Application Kit 3 Numbers":"D5455,D5456",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"Plasma?NGS@Bisulfite?Whole Genome Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"zymo-seq-trio-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"zymo-seq-wgbs-library-kit",
		"Application Kit 2 Numbers":"D5465",
		"Application Kit 3 Handle":"pico-methyl-seq-library-prep-kit",
		"Application Kit 3 Numbers":"D5455,D5456",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"Urine?NGS@Bisulfite?Whole Genome Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-urine-kit",
		"Extraction Kit Numbers":"D3061",
		"Application Kit Handle":"zymo-seq-trio-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"zymo-seq-wgbs-library-kit",
		"Application Kit 2 Numbers":"D5465",
		"Application Kit 3 Handle":"pico-methyl-seq-library-prep-kit",
		"Application Kit 3 Numbers":"D5455,D5456",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"Microbe?NGS@Bisulfite?Whole Genome Bisulfite Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300,D4300T,D4304",
		"Extraction Kit 2 Handle":"quick-dna-fungal-bacterial-miniprep-kit",
		"Extraction Kit 2 Numbers":"D6005",
		"Extraction Kit 3 Handle":"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		"Extraction Kit 3 Numbers":"D6010",
		"Application Kit Handle":"zymo-seq-trio-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"zymo-seq-wgbs-library-kit",
		"Application Kit 2 Numbers":"D5465",
		"Application Kit 3 Handle":"pico-methyl-seq-library-prep-kit",
		"Application Kit 3 Numbers":"D5455,D5456",
	},
	"Insect?NGS@Bisulfite?Whole Genome Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-tissue-insect-miniprep-kit",
		"Extraction Kit Numbers":"D6016",
		"Application Kit Handle":"zymo-seq-trio-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"zymo-seq-wgbs-library-kit",
		"Application Kit 2 Numbers":"D5465",
		"Application Kit 3 Handle":"pico-methyl-seq-library-prep-kit",
		"Application Kit 3 Numbers":"D5455,D5456",
	},
	"Plant?NGS@Bisulfite?Whole Genome Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-plant-seed-miniprep-kit",
		"Extraction Kit Numbers":"D6020",
		"Application Kit Handle":"zymo-seq-trio-wgbs-library-kit",
		"Application Kit Numbers":"D5462,D5463",
		"Application Kit 2 Handle":"zymo-seq-wgbs-library-kit",
		"Application Kit 2 Numbers":"D5465",
		"Application Kit 3 Handle":"pico-methyl-seq-library-prep-kit",
		"Application Kit 3 Numbers":"D5455,D5456",
	},
	"Cells?NGS@Bisulfite?Reduced Representation Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-miniprep",
		"Extraction Kit Numbers":"D3024,D3025",
		"Application Kit Handle":"zymo-seq-rrbs-library-kit",
		"Application Kit Numbers":"D5460,D5461",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"Tissue?NGS@Bisulfite?Reduced Representation Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"zymo-seq-rrbs-library-kit",
		"Application Kit Numbers":"D5460,D5461",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"FFPE?NGS@Bisulfite?Reduced Representation Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-ffpe-miniprep",
		"Extraction Kit Numbers":"D3067",
		"Application Kit Handle":"zymo-seq-rrbs-library-kit",
		"Application Kit Numbers":"D5460,D5461",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"cfDNA?NGS@Bisulfite?Reduced Representation Bisulfite Sequencing": {
		"Extraction Kit Handle":"magicbead-cfdna-isolation-kit",
		"Extraction Kit Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-rrbs-library-kit",
		"Application Kit Numbers":"D5460,D5461",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"Blood?NGS@Bisulfite?Reduced Representation Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"zymo-seq-rrbs-library-kit",
		"Application Kit Numbers":"D5460,D5461",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"Serum?NGS@Bisulfite?Reduced Representation Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"zymo-seq-rrbs-library-kit",
		"Application Kit Numbers":"D5460,D5461",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"Plasma?NGS@Bisulfite?Reduced Representation Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"zymo-seq-rrbs-library-kit",
		"Application Kit Numbers":"D5460,D5461",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"Urine?NGS@Bisulfite?Reduced Representation Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-urine-kit",
		"Extraction Kit Numbers":"D3061",
		"Application Kit Handle":"zymo-seq-rrbs-library-kit",
		"Application Kit Numbers":"D5460,D5461",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-dna-set-dna-w-primers,zymo-seq-methyl-spike-in-control",
		"Controls Numbers":"D5011,D5012,D5014,D5500",
	},
	"Microbe?NGS@Bisulfite?Reduced Representation Bisulfite Sequencing": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300,D4300T,D4304",
		"Extraction Kit 2 Handle":"quick-dna-fungal-bacterial-miniprep-kit",
		"Extraction Kit 2 Numbers":"D6005",
		"Extraction Kit 3 Handle":"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		"Extraction Kit 3 Numbers":"D6010",
		"Application Kit Handle":"zymo-seq-rrbs-library-kit",
		"Application Kit Numbers":"D5460,D5461",
	},
	"Insect?NGS@Bisulfite?Reduced Representation Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-tissue-insect-miniprep-kit",
		"Extraction Kit Numbers":"D6016",
		"Application Kit Handle":"zymo-seq-rrbs-library-kit",
		"Application Kit Numbers":"D5460,D5461",
	},
	"Plant?NGS@Bisulfite?Reduced Representation Bisulfite Sequencing": {
		"Extraction Kit Handle":"quick-dna-plant-seed-miniprep-kit",
		"Extraction Kit Numbers":"D6020",
		"Application Kit Handle":"zymo-seq-rrbs-library-kit",
		"Application Kit Numbers":"D5460,D5461",
	},
	"Cells?PCR/qPCR@Bisulfite?Bisulfite Specific": {
		"Extraction Kit Handle":"quick-dna-miniprep",
		"Extraction Kit Numbers":"D3024,D3025",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers,bisulfite-converted-universal-methylated-human-dna-standard,e-coli-non-methylated-genomic-dna,methylated-non-methylated-puc19-dna-set,human-matched-dna-set,mouse-5hmc-5mc-dna-set",
		"Controls Numbers":"D5011,D5012,D5013,D5014,D5015,D5016,D5017,D5018,D5019",
	},
	"Tissue?PCR/qPCR@Bisulfite?Bisulfite Specific": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers,bisulfite-converted-universal-methylated-human-dna-standard,e-coli-non-methylated-genomic-dna,methylated-non-methylated-puc19-dna-set,human-matched-dna-set,mouse-5hmc-5mc-dna-set",
		"Controls Numbers":"D5011,D5012,D5013,D5014,D5015,D5016,D5017,D5018,D5019",
	},
	"FFPE?PCR/qPCR@Bisulfite?Bisulfite Specific": {
		"Extraction Kit Handle":"quick-dna-ffpe-miniprep",
		"Extraction Kit Numbers":"D3067",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers,bisulfite-converted-universal-methylated-human-dna-standard,e-coli-non-methylated-genomic-dna,methylated-non-methylated-puc19-dna-set,human-matched-dna-set,mouse-5hmc-5mc-dna-set",
		"Controls Numbers":"D5011,D5012,D5013,D5014,D5015,D5016,D5017,D5018,D5019",
	},
	"cfDNA?PCR/qPCR@Bisulfite?Bisulfite Specific": {
		"Extraction Kit Handle":"magicbead-cfdna-isolation-kit",
		"Extraction Kit Numbers":"D4086",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers,bisulfite-converted-universal-methylated-human-dna-standard,e-coli-non-methylated-genomic-dna,methylated-non-methylated-puc19-dna-set,human-matched-dna-set,mouse-5hmc-5mc-dna-set",
		"Controls Numbers":"D5011,D5012,D5013,D5014,D5015,D5016,D5017,D5018,D5019",
	},
	"Blood?PCR/qPCR@Bisulfite?Bisulfite Specific": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers,bisulfite-converted-universal-methylated-human-dna-standard,e-coli-non-methylated-genomic-dna,methylated-non-methylated-puc19-dna-set,human-matched-dna-set,mouse-5hmc-5mc-dna-set",
		"Controls Numbers":"D5011,D5012,D5013,D5014,D5015,D5016,D5017,D5018,D5019",
	},
	"Serum?PCR/qPCR@Bisulfite?Bisulfite Specific": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers,bisulfite-converted-universal-methylated-human-dna-standard,e-coli-non-methylated-genomic-dna,methylated-non-methylated-puc19-dna-set,human-matched-dna-set,mouse-5hmc-5mc-dna-set",
		"Controls Numbers":"D5011,D5012,D5013,D5014,D5015,D5016,D5017,D5018,D5019",
	},
	"Plasma?PCR/qPCR@Bisulfite?Bisulfite Specific": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers,bisulfite-converted-universal-methylated-human-dna-standard,e-coli-non-methylated-genomic-dna,methylated-non-methylated-puc19-dna-set,human-matched-dna-set,mouse-5hmc-5mc-dna-set",
		"Controls Numbers":"D5011,D5012,D5013,D5014,D5015,D5016,D5017,D5018,D5019",
	},
	"Urine?PCR/qPCR@Bisulfite?Bisulfite Specific": {
		"Extraction Kit Handle":"quick-dna-urine-kit",
		"Extraction Kit Numbers":"D3061",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"universal-methylated-dna-standard,human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers,bisulfite-converted-universal-methylated-human-dna-standard,e-coli-non-methylated-genomic-dna,methylated-non-methylated-puc19-dna-set,human-matched-dna-set,mouse-5hmc-5mc-dna-set",
		"Controls Numbers":"D5011,D5012,D5013,D5014,D5015,D5016,D5017,D5018,D5019",
	},
	"Microbe?PCR/qPCR@Bisulfite?Bisulfite Specific": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300,D4300T,D4304",
		"Extraction Kit 2 Handle":"quick-dna-fungal-bacterial-miniprep-kit",
		"Extraction Kit 2 Numbers":"D6005",
		"Extraction Kit 3 Handle":"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		"Extraction Kit 3 Numbers":"D6010",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"e-coli-non-methylated-genomic-dna",
		"Controls Numbers":"D5016",
	},
	"Insect?PCR/qPCR@Bisulfite?Bisulfite Specific": {
		"Extraction Kit Handle":"quick-dna-tissue-insect-miniprep-kit",
		"Extraction Kit Numbers":"D6016",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
	},
	"Plant?PCR/qPCR@Bisulfite?Bisulfite Specific": {
		"Extraction Kit Handle":"quick-dna-plant-seed-miniprep-kit",
		"Extraction Kit Numbers":"D6020",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
	},
	"Cells?PCR/qPCR@Bisulfite?Methylation Specific": {
		"Extraction Kit Handle":"quick-dna-miniprep",
		"Extraction Kit Numbers":"D3024,D3025",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5013,D5014",
	},
	"Tissue?PCR/qPCR@Bisulfite?Methylation Specific": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5013,D5014",
	},
	"FFPE?PCR/qPCR@Bisulfite?Methylation Specific": {
		"Extraction Kit Handle":"quick-dna-ffpe-miniprep",
		"Extraction Kit Numbers":"D3067",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5013,D5014",
	},
	"cfDNA?PCR/qPCR@Bisulfite?Methylation Specific": {
		"Extraction Kit Handle":"magicbead-cfdna-isolation-kit",
		"Extraction Kit Numbers":"D4086",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5013,D5014",
	},
	"Blood?PCR/qPCR@Bisulfite?Methylation Specific": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5013,D5014",
	},
	"Serum?PCR/qPCR@Bisulfite?Methylation Specific": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5013,D5014",
	},
	"Plasma?PCR/qPCR@Bisulfite?Methylation Specific": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5013,D5014",
	},
	"Urine?PCR/qPCR@Bisulfite?Methylation Specific": {
		"Extraction Kit Handle":"quick-dna-urine-kit",
		"Extraction Kit Numbers":"D3061",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers,human-methylated-non-methylated-dna-set-dna-w-primers",
		"Controls Numbers":"D5013,D5014",
	},
	"Microbe?PCR/qPCR@Bisulfite?Methylation Specific": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300,D4300T,D4304",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
	},
	"Insect?PCR/qPCR@Bisulfite?Methylation Specific": {
		"Extraction Kit Handle":"quick-dna-tissue-insect-miniprep-kit",
		"Extraction Kit Numbers":"D6016",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
	},
	"Plant?PCR/qPCR@Bisulfite?Methylation Specific": {
		"Extraction Kit Handle":"quick-dna-plant-seed-miniprep-kit",
		"Extraction Kit Numbers":"D6020",
		"Application Kit Handle":"ez-dna-methylation-lightning-kit",
		"Application Kit Numbers":"D5030-E,D5031-E,D5030T,D5030,D5031",
		"Application Kit 2 Handle":"zymotaq-premix",
		"Application Kit 2 Numbers":"E2003,E2004",
		"Application Kit 3 Handle":"zymotaq-dna-polymerase",
		"Application Kit 3 Numbers":"E2001,E2002",
		"Application Kit 4 Handle":"zymotaq-qpcr-premix",
		"Application Kit 4 Numbers":"E2054,E2055",
	},
	"Cells?Illumina Methylation Array@Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-miniprep",
		"Extraction Kit Numbers":"D3024,D3025",
		"Application Kit Handle":"ez-96-dna-methylation-lightning-magprep,ez-dna-methylation-lightning-automation-kit",
		"Application Kit Numbers":"D5046,D5047,D5049",
		"Application Kit 2 Handle":"ez-dna-methylation-kit,ez-96-dna-methylation-kit",
		"Application Kit 2 Numbers":"D5001,D5002,D5004",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		"Controls Numbers":"D5013-1",
	},
	"Tissue?Illumina Methylation Array@Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"ez-96-dna-methylation-lightning-magprep,ez-dna-methylation-lightning-automation-kit",
		"Application Kit Numbers":"D5046,D5047,D5049",
		"Application Kit 2 Handle":"ez-dna-methylation-kit,ez-96-dna-methylation-kit",
		"Application Kit 2 Numbers":"D5001,D5002,D5004",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		"Controls Numbers":"D5013-1",
	},
	"FFPE?Illumina Methylation Array@Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-ffpe-miniprep",
		"Extraction Kit Numbers":"D3067",
		"Application Kit Handle":"ez-96-dna-methylation-lightning-magprep,ez-dna-methylation-lightning-automation-kit",
		"Application Kit Numbers":"D5046,D5047,D5049",
		"Application Kit 2 Handle":"ez-dna-methylation-kit,ez-96-dna-methylation-kit",
		"Application Kit 2 Numbers":"D5001,D5002,D5004",
		"Application Kit 3 Handle":"zr-96-dna-clean-amp-concentrator-5-deep-well",
		"Application Kit 3 Numbers":"D4023",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		"Controls Numbers":"D5013-1",
	},
	"Blood?Illumina Methylation Array@Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"ez-96-dna-methylation-lightning-magprep,ez-dna-methylation-lightning-automation-kit",
		"Application Kit Numbers":"D5046,D5047,D5049",
		"Application Kit 2 Handle":"ez-dna-methylation-kit,ez-96-dna-methylation-kit",
		"Application Kit 2 Numbers":"D5001,D5002,D5004",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		"Controls Numbers":"D5013-1",
	},
	"Serum?Illumina Methylation Array@Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"ez-96-dna-methylation-lightning-magprep,ez-dna-methylation-lightning-automation-kit",
		"Application Kit Numbers":"D5046,D5047,D5049",
		"Application Kit 2 Handle":"ez-dna-methylation-kit,ez-96-dna-methylation-kit",
		"Application Kit 2 Numbers":"D5001,D5002,D5004",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		"Controls Numbers":"D5013-1",
	},
	"Plasma?Illumina Methylation Array@Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"ez-96-dna-methylation-lightning-magprep,ez-dna-methylation-lightning-automation-kit",
		"Application Kit Numbers":"D5046,D5047,D5049",
		"Application Kit 2 Handle":"ez-dna-methylation-kit,ez-96-dna-methylation-kit",
		"Application Kit 2 Numbers":"D5001,D5002,D5004",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		"Controls Numbers":"D5013-1",
	},
	"Urine?Illumina Methylation Array@Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-urine-kit",
		"Extraction Kit Numbers":"D3061",
		"Application Kit Handle":"ez-96-dna-methylation-lightning-magprep,ez-dna-methylation-lightning-automation-kit",
		"Application Kit Numbers":"D5046,D5047,D5049",
		"Application Kit 2 Handle":"ez-dna-methylation-kit,ez-96-dna-methylation-kit",
		"Application Kit 2 Numbers":"D5001,D5002,D5004",
		"Controls Handle":"human-methylated-non-methylated-wga-dna-set-dna-w-primers",
		"Controls Numbers":"D5013-1",
	},
	"Cells?qPCR@Non-Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-miniprep",
		"Extraction Kit Numbers":"D3024,D3025",
		"Application Kit Handle":"onestep-plus-qmethyl-pcr-kit",
		"Application Kit Numbers":"D5312",
	},
	"Tissue?qPCR@Non-Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"onestep-plus-qmethyl-pcr-kit",
		"Application Kit Numbers":"D5312",
	},
	"FFPE?qPCR@Non-Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-ffpe-miniprep",
		"Extraction Kit Numbers":"D3067",
		"Application Kit Handle":"onestep-plus-qmethyl-pcr-kit",
		"Application Kit Numbers":"D5312",
	},
	"cfDNA?qPCR@Non-Bisulfite?General/Other": {
		"Extraction Kit Handle":"magicbead-cfdna-isolation-kit",
		"Extraction Kit Numbers":"D4086",
		"Application Kit Handle":"onestep-plus-qmethyl-pcr-kit",
		"Application Kit Numbers":"D5312",
	},
	"Blood?qPCR@Non-Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"onestep-plus-qmethyl-pcr-kit",
		"Application Kit Numbers":"D5312",
	},
	"Serum?qPCR@Non-Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"onestep-plus-qmethyl-pcr-kit",
		"Application Kit Numbers":"D5312",
	},
	"Plasma?qPCR@Non-Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"onestep-plus-qmethyl-pcr-kit",
		"Application Kit Numbers":"D5312",
	},
	"Urine?qPCR@Non-Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-urine-kit",
		"Extraction Kit Numbers":"D3061",
		"Application Kit Handle":"onestep-plus-qmethyl-pcr-kit",
		"Application Kit Numbers":"D5312",
	},
	"Microbe?qPCR@Non-Bisulfite?General/Other": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300,D4300T,D4304",
		"Extraction Kit 2 Handle":"quick-dna-fungal-bacterial-miniprep-kit",
		"Extraction Kit 2 Numbers":"D6005",
		"Extraction Kit 3 Handle":"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		"Extraction Kit 3 Numbers":"D6010",
		"Application Kit Handle":"onestep-plus-qmethyl-pcr-kit",
		"Application Kit Numbers":"D5312",
	},
	"Insect?qPCR@Non-Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-tissue-insect-miniprep-kit",
		"Extraction Kit Numbers":"D6016",
		"Application Kit Handle":"onestep-plus-qmethyl-pcr-kit",
		"Application Kit Numbers":"D5312",
	},
	"Plant?qPCR@Non-Bisulfite?General/Other": {
		"Extraction Kit Handle":"quick-dna-plant-seed-miniprep-kit",
		"Extraction Kit Numbers":"D6020",
		"Application Kit Handle":"onestep-plus-qmethyl-pcr-kit",
		"Application Kit Numbers":"D5312",
	},
	"Cells?ELISA@Non-Bisulfite?5-mC": {
		"Extraction Kit Handle":"quick-dna-miniprep",
		"Extraction Kit Numbers":"D3024,D3025",
		"Application Kit Handle":"5-mc-dna-elisa-kit",
		"Application Kit Numbers":"D5325,D5326",
	},
	"Tissue?ELISA@Non-Bisulfite?5-mC": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"5-mc-dna-elisa-kit",
		"Application Kit Numbers":"D5325,D5326",
	},
	"FFPE?ELISA@Non-Bisulfite?5-mC": {
		"Extraction Kit Handle":"quick-dna-ffpe-miniprep",
		"Extraction Kit Numbers":"D3067",
		"Application Kit Handle":"5-mc-dna-elisa-kit",
		"Application Kit Numbers":"D5325,D5326",
	},
	"cfDNA?ELISA@Non-Bisulfite?5-mC": {
		"Extraction Kit Handle":"magicbead-cfdna-isolation-kit",
		"Extraction Kit Numbers":"D4086",
		"Application Kit Handle":"5-mc-dna-elisa-kit",
		"Application Kit Numbers":"D5325,D5326",
	},
	"Blood?ELISA@Non-Bisulfite?5-mC": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"5-mc-dna-elisa-kit",
		"Application Kit Numbers":"D5325,D5326",
	},
	"Serum?ELISA@Non-Bisulfite?5-mC": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"5-mc-dna-elisa-kit",
		"Application Kit Numbers":"D5325,D5326",
	},
	"Plasma?ELISA@Non-Bisulfite?5-mC": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"5-mc-dna-elisa-kit",
		"Application Kit Numbers":"D5325,D5326",
	},
	"Urine?ELISA@Non-Bisulfite?5-mC": {
		"Extraction Kit Handle":"quick-dna-urine-kit",
		"Extraction Kit Numbers":"D3061",
		"Application Kit Handle":"5-mc-dna-elisa-kit",
		"Application Kit Numbers":"D5325,D5326",
	},
	"Microbe?ELISA@Non-Bisulfite?5-mC": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300,D4300T,D4304",
		"Extraction Kit 2 Handle":"quick-dna-fungal-bacterial-miniprep-kit",
		"Extraction Kit 2 Numbers":"D6005",
		"Extraction Kit 3 Handle":"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		"Extraction Kit 3 Numbers":"D6010",
		"Application Kit Handle":"5-mc-dna-elisa-kit",
		"Application Kit Numbers":"D5325,D5326",
	},
	"Insect?ELISA@Non-Bisulfite?5-mC": {
		"Extraction Kit Handle":"quick-dna-tissue-insect-miniprep-kit",
		"Extraction Kit Numbers":"D6016",
		"Application Kit Handle":"5-mc-dna-elisa-kit",
		"Application Kit Numbers":"D5325,D5326",
	},
	"Plant?ELISA@Non-Bisulfite?5-mC": {
		"Extraction Kit Handle":"quick-dna-plant-seed-miniprep-kit",
		"Extraction Kit Numbers":"D6020",
		"Application Kit Handle":"5-mc-dna-elisa-kit",
		"Application Kit Numbers":"D5325,D5326",
	},
	"Cells?NGS@Non-Bisulfite?Fragmentomics": {
		"Extraction Kit Handle":"quick-dna-miniprep",
		"Extraction Kit Numbers":"D3024,D3025",
		"Application Kit Handle":"zymo-seq-splat-dna-library-kit",
		"Application Kit Numbers":"D5464",
	},
	"Tissue?NGS@Non-Bisulfite?Fragmentomics": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"zymo-seq-splat-dna-library-kit",
		"Application Kit Numbers":"D5464",
	},
	"FFPE?NGS@Non-Bisulfite?Fragmentomics": {
		"Extraction Kit Handle":"quick-dna-ffpe-miniprep",
		"Extraction Kit Numbers":"D3067",
		"Application Kit Handle":"zymo-seq-splat-dna-library-kit",
		"Application Kit Numbers":"D5464",
	},
	"cfDNA?NGS@Non-Bisulfite?Fragmentomics": {
		"Extraction Kit Handle":"magicbead-cfdna-isolation-kit",
		"Extraction Kit Numbers":"D4086",
		"Application Kit Handle":"zymo-seq-splat-dna-library-kit",
		"Application Kit Numbers":"D5464",
	},
	"Cells?NGS@Non-Bisulfite?Chromatin": {
		"Application Kit Handle":"zymo-seq-atac-library-kit",
		"Application Kit Numbers":"D5458",
		"Application Kit 2 Handle":"zymo-spin-chip-kit",
		"Application Kit 2 Numbers":"D5209,D5210",
		"Application Kit 3 Handle":"chip-dna-clean-concentrator",
		"Application Kit 3 Numbers":"D5201,D5205,D5206,D5207",
		"Application Kit 4 Handle":"ez-nucleosomal-dna-prep-kit",
		"Application Kit 4 Numbers":"D5220",
	},
	"Cells?ELISA@Non-Bisulfite?5-hmC": {
		"Extraction Kit Handle":"quick-dna-miniprep",
		"Extraction Kit Numbers":"D3024,D3025",
		"Application Kit Handle":"quest-5-hmc-dna-elisa-kit",
		"Application Kit Numbers":"D5425,D5426",
	},
	"Tissue?ELISA@Non-Bisulfite?5-hmC": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"quest-5-hmc-dna-elisa-kit",
		"Application Kit Numbers":"D5425,D5426",
	},
	"FFPE?ELISA@Non-Bisulfite?5-hmC": {
		"Extraction Kit Handle":"quick-dna-ffpe-miniprep",
		"Extraction Kit Numbers":"D3067",
		"Application Kit Handle":"quest-5-hmc-dna-elisa-kit",
		"Application Kit Numbers":"D5425,D5426",
	},
	"cfDNA?ELISA@Non-Bisulfite?5-hmC": {
		"Extraction Kit Handle":"magicbead-cfdna-isolation-kit",
		"Extraction Kit Numbers":"D4086",
		"Application Kit Handle":"quest-5-hmc-dna-elisa-kit",
		"Application Kit Numbers":"D5425,D5426",
	},
	"Blood?ELISA@Non-Bisulfite?5-hmC": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"quest-5-hmc-dna-elisa-kit",
		"Application Kit Numbers":"D5425,D5426",
	},
	"Serum?ELISA@Non-Bisulfite?5-hmC": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"quest-5-hmc-dna-elisa-kit",
		"Application Kit Numbers":"D5425,D5426",
	},
	"Plasma?ELISA@Non-Bisulfite?5-hmC": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"quest-5-hmc-dna-elisa-kit",
		"Application Kit Numbers":"D5425,D5426",
	},
	"Urine?ELISA@Non-Bisulfite?5-hmC": {
		"Extraction Kit Handle":"quick-dna-urine-kit",
		"Extraction Kit Numbers":"D3061",
		"Application Kit Handle":"quest-5-hmc-dna-elisa-kit",
		"Application Kit Numbers":"D5425,D5426",
	},
	"Microbe?ELISA@Non-Bisulfite?5-hmC": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300,D4300T,D4304",
		"Extraction Kit 2 Handle":"quick-dna-fungal-bacterial-miniprep-kit",
		"Extraction Kit 2 Numbers":"D6005",
		"Extraction Kit 3 Handle":"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		"Extraction Kit 3 Numbers":"D6010",
		"Application Kit Handle":"quest-5-hmc-dna-elisa-kit",
		"Application Kit Numbers":"D5425,D5426",
	},
	"Insect?ELISA@Non-Bisulfite?5-hmC": {
		"Extraction Kit Handle":"quick-dna-tissue-insect-miniprep-kit",
		"Extraction Kit Numbers":"D6016",
		"Application Kit Handle":"quest-5-hmc-dna-elisa-kit",
		"Application Kit Numbers":"D5425,D5426",
	},
	"Plant?ELISA@Non-Bisulfite?5-hmC": {
		"Extraction Kit Handle":"quick-dna-plant-seed-miniprep-kit",
		"Extraction Kit Numbers":"D6020",
		"Application Kit Handle":"quest-5-hmc-dna-elisa-kit",
		"Application Kit Numbers":"D5425,D5426",
	},
	"Cells?NGS@Non-Bisulfite?5-hmC Reduced Representation Hydroxymethylcytosine Profiling": {
		"Extraction Kit Handle":"quick-dna-miniprep",
		"Extraction Kit Numbers":"D3024,D3025",
		"Application Kit Handle":"rrhp-5-hmc-library-prep-kit",
		"Application Kit Numbers":"D5450,D5451",
	},
	"Tissue?NGS@Non-Bisulfite?5-hmC Reduced Representation Hydroxymethylcytosine Profiling": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"rrhp-5-hmc-library-prep-kit",
		"Application Kit Numbers":"D5450,D5451",
	},
	"FFPE?NGS@Non-Bisulfite?5-hmC Reduced Representation Hydroxymethylcytosine Profiling": {
		"Extraction Kit Handle":"quick-dna-ffpe-miniprep",
		"Extraction Kit Numbers":"D3067",
		"Application Kit Handle":"rrhp-5-hmc-library-prep-kit",
		"Application Kit Numbers":"D5450,D5451",
	},
	"cfDNA?NGS@Non-Bisulfite?5-hmC Reduced Representation Hydroxymethylcytosine Profiling": {
		"Extraction Kit Handle":"magicbead-cfdna-isolation-kit",
		"Extraction Kit Numbers":"D4086",
		"Application Kit Handle":"rrhp-5-hmc-library-prep-kit",
		"Application Kit Numbers":"D5450,D5451",
	},
	"Blood?NGS@Non-Bisulfite?5-hmC Reduced Representation Hydroxymethylcytosine Profiling": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"rrhp-5-hmc-library-prep-kit",
		"Application Kit Numbers":"D5450,D5451",
	},
	"Serum?NGS@Non-Bisulfite?5-hmC Reduced Representation Hydroxymethylcytosine Profiling": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"rrhp-5-hmc-library-prep-kit",
		"Application Kit Numbers":"D5450,D5451",
	},
	"Plasma?NGS@Non-Bisulfite?5-hmC Reduced Representation Hydroxymethylcytosine Profiling": {
		"Extraction Kit Handle":"quick-dna-miniprep-plus-kit",
		"Extraction Kit Numbers":"D4068,D4068T,D4069",
		"Application Kit Handle":"rrhp-5-hmc-library-prep-kit",
		"Application Kit Numbers":"D5450,D5451",
	},
	"Urine?NGS@Non-Bisulfite?5-hmC Reduced Representation Hydroxymethylcytosine Profiling": {
		"Extraction Kit Handle":"quick-dna-urine-kit",
		"Extraction Kit Numbers":"D3061",
		"Application Kit Handle":"rrhp-5-hmc-library-prep-kit",
		"Application Kit Numbers":"D5450,D5451",
	},
	"Microbe?NGS@Non-Bisulfite?5-hmC Reduced Representation Hydroxymethylcytosine Profiling": {
		"Extraction Kit Handle":"zymobiomics-dna-miniprep-kit",
		"Extraction Kit Numbers":"D4300,D4300T,D4304",
		"Extraction Kit 2 Handle":"quick-dna-fungal-bacterial-miniprep-kit",
		"Extraction Kit 2 Numbers":"D6005",
		"Extraction Kit 3 Handle":"quick-dna-fecal-soil-microbe-dna-miniprep-kit",
		"Extraction Kit 3 Numbers":"D6010",
		"Application Kit Handle":"rrhp-5-hmc-library-prep-kit",
		"Application Kit Numbers":"D5450,D5451",
	},
	"Insect?NGS@Non-Bisulfite?5-hmC Reduced Representation Hydroxymethylcytosine Profiling": {
		"Extraction Kit Handle":"quick-dna-tissue-insect-miniprep-kit",
		"Extraction Kit Numbers":"D6016",
		"Application Kit Handle":"rrhp-5-hmc-library-prep-kit",
		"Application Kit Numbers":"D5450,D5451",
	},
	"Plant?NGS@Non-Bisulfite?5-hmC Reduced Representation Hydroxymethylcytosine Profiling": {
		"Extraction Kit Handle":"quick-dna-plant-seed-miniprep-kit",
		"Extraction Kit Numbers":"D6020",
		"Application Kit Handle":"rrhp-5-hmc-library-prep-kit",
		"Application Kit Numbers":"D5450,D5451",
	},
}